import CalendarMonth from './CalendarMonth.react';

class Calendar extends React.Component {

    constructor(props) {
        super(props);

        var date = this.props.date;

        this.state = {
            // date    : this.props.date,
            visible : false,
            uuid    : uuid(),

            year    : date ? moment(date).format('YYYY') : moment(new Date()).format('YYYY'),
            month   : date ? moment(date).format('MM') : moment(new Date()).format('MM'),
            day     : date ? moment(date).format('DD') : moment(new Date()).format('DD'),

            today   : moment(new Date()).format('YYYY-MM-DD'),
        };

        this.mouseListener = this.mouseListener.bind(this);
        this.show = this.show.bind(this);
        this.hide = this.hide.bind(this);
        this.nextMonth = this.nextMonth.bind(this);
        this.prevMonth = this.prevMonth.bind(this);
        this.selectDate = this.selectDate.bind(this);
    }

    componentDidMount() {
        $(window).on('click', this.mouseListener);
    }

    componentWillUnmount() {
        $(window).off('click', this.mouseListener);
    }

    mouseListener(e) {
        if(!$(e.target).closest('#'+this.state.uuid).length) {
            if (this.state.visible)
                this.hide();
        }
    }

    show() {
        var self = this;

        this.setState({
            visible : true,
        }, function() {
            $('#'+self.state.uuid).css({ 'z-index' : 9999 });
            $('#content_'+self.state.uuid).css({
                'opacity' : 1,
            });
            $('#input_'+self.state.uuid).addClass('calendar__date--active');
        });
    }

    hide() {
        var self = this;

        $('#'+this.state.uuid).css({ 'z-index' : 0 });
        $('#content_'+this.state.uuid).css({'opacity' : 0});
        $('#input_'+self.state.uuid).removeClass('calendar__date--active');

        setTimeout(() => {
            this.setState({ visible : false });
        }, 1000);
    }

    getDaysArrayByMonth(year, month) {

        var daysInMonth = moment(year+'-'+month, 'YYYY-MM').daysInMonth();
        var arrDays = [];

        for (var i=1; i<=daysInMonth; i++) {

            arrDays.push({
                date : moment(year+'-'+month+'-'+i, 'YYYY-MM-DD').format('YYYY-MM-DD'),
                ddd  : moment(year+'-'+month+'-'+i, 'YYYY-MM-DD').format('ddd'),
            });

            if (moment(year+'-'+month+'-'+i, 'YYYY-MM-DD').format('ddd') === 'Sat')
                arrDays.push({
                    date : false,
                    ddd  : false,
                });
        }

        return arrDays;
    }

    selectDate(date) {
        if (this.props.selectDate)
            this.props.selectDate(date);

        this.hide();
    }

    nextMonth() {
        this.setState({
            year  : parseInt(this.state.month) + 1 <= 12 ? parseInt(this.state.year) : parseInt(this.state.year) + 1,
            month : parseInt(this.state.month) + 1 <= 12 ? parseInt(this.state.month) + 1 : 1,
        });
    }

    prevMonth() {
        this.setState({
            year  : this.state.month - 1 >= 1 ? this.state.year : this.state.year - 1,
            month : this.state.month - 1 >= 1 ? this.state.month - 1 : 12,
        });
    }

    render() {
        var year         = this.state.year;
        var month        = this.state.month;

        var first_month  = this.getDaysArrayByMonth(year, month);
        var second_month = this.getDaysArrayByMonth(
            month + 1 > 12 ? year + 1 : year,
            month + 1 > 12 ? 1 : month + 1
        );

        var allowPastDate = this.props.allowPastDate;

        return (
            <div
                className={'calendar '+this.props.className}
                style={(this.props.style ? this.props.style : {})}
                id={this.state.uuid}>

                <input
                    className={'input calendar__date '+this.props.inputClass}
                    id={'input_'+this.state.uuid}
                    type='text'
                    value={!this.props.date ? this.props.placeHolder : this.props.date}
                    onClick={this.show} />

                { this.state.visible &&
                    <div
                        className='calendar__content'
                        id={'content_'+this.state.uuid}>

                        <div className='cal-header'>
                            <div className='cal-header__first'>
                                { moment(first_month[0].date).format('MMMM, YYYY')}
                            </div>
                        </div>

                        <CalendarMonth
                            className='cal-month__first'
                            data={first_month}
                            today={this.state.today}
                            selected={this.props.date}
                            selectDate={this.selectDate}
                            allowPastDate={allowPastDate} />

                        <div
                            className='calendar__prev'
                            onClick={this.prevMonth} >

                            <i
                                className="fa fa-arrow-left"
                                aria-hidden="true"/>
                        </div>

                        <div
                            className='calendar__next'
                            onClick={this.nextMonth} >

                            <i
                                className="fa fa-arrow-right"
                                aria-hidden="true" />
                        </div>

                    </div>
                }

            </div>
        );
    }
}

export default Calendar;


/*

                        <div
                            className='close calendar__close'
                            onClick={this.hide}>

                            <i className="fa fa-times" aria-hidden="true"></i>
                        </div>

*/



// WEBPACK FOOTER //
// ./ui_src/app/components/form/Calendar.react.jsx